/**
 * @fileoverview Dispatcher component that routes to either ProjectDetailPage or
 * ViewNotePage based on the ID prefix. Project IDs start with 'pr', note IDs
 * start with 'no'.
 *
 * Both target pages are lazy-loaded so their (heavy) code — project kanban,
 * markdown/mermaid rendering — is split out of the main bundle and only fetched
 * when a dynamic id route is actually visited.
 */

import * as React from 'react';
import { useParams } from 'react-router';
import { LinearProgress } from '@mui/material';

const ProjectDetailPage = React.lazy(() => import('../../features/projects/pages/ProjectDetailPage'));
const ViewNotePage = React.lazy(() => import('../../features/notes/pages/ViewNotePage'));

export default function DynamicIdPage(): React.JSX.Element {
  const { id } = useParams<{ id: string }>();

  // Project IDs start with 'pr', note IDs start with 'no'
  const Page = id?.startsWith('pr') ? ProjectDetailPage : ViewNotePage;

  return (
    <React.Suspense fallback={<LinearProgress />}>
      <Page />
    </React.Suspense>
  );
}
